export enum AuditLogsLabelEnum {
  DateOfChange = 'Date of Change (UTC)',
  User = 'User',
  Activity = 'Activity',
  Outcome = 'Outcome',
  Remarks = 'Remarks',
}
